import Renew16 from '@carbon/icons-react/es/renew/16';
import { Col, Row as AntRow } from 'antd';
import React from 'react';
import styled from 'styled-components';
import { JiraConfig } from 'api/integrations';
import { Button } from 'components/atoms/button';
import { useTranslation } from 'hooks/use-translation';
import { Help, Title } from '../styles';

const Row = styled(AntRow)`
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 16px;
`;

export const Heading = ({
  jiraConfig,
  onRefresh,
  loading,
}: {
  loading?: boolean;
  jiraConfig: JiraConfig;
  onRefresh: (integrationId: number) => void;
}): JSX.Element => {
  const title = useTranslation(
    'settings.integrations.jira.field_settings.title',
  );
  const help = useTranslation('settings.integrations.jira.field_settings.help');
  const refreshText = useTranslation(
    'settings.integrations.jira.field_settings.refresh',
  );

  return (
    <Row align="middle">
      <Col span={16}>
        <Title>{title}</Title>
        <Help noMargin>{help}</Help>
      </Col>
      <Col span={6} offset={2}>
        <Button
          type="link"
          icon={<Renew16 />}
          iconPlacement="right"
          onClick={() => onRefresh(jiraConfig.integrationId)}
          disabled={loading}
          loading={loading}
        >
          {refreshText}
        </Button>
      </Col>
    </Row>
  );
};
